const SUIT_SYMBOL: Record<string, string> = {
  H: '♥',
  D: '♦',
  C: '♣',
  S: '♠',
};

const VALID_CODE = /^([2-9]|10|[JQKA])[HDCS]$/i;

export function isValidCardCode(code: string): boolean {
  return VALID_CODE.test(code.trim());
}

export function parseCardCode(code: string): {
  rank: string;
  suit: string;
  suitKey: string;
  red: boolean;
  valid: boolean;
} {
  if (!isValidCardCode(code)) {
    return { rank: '', suit: '', suitKey: '', red: false, valid: false };
  }
  const normalized = code.trim().toUpperCase();
  const suitKey = normalized.slice(-1);
  const rank = normalized.slice(0, -1);
  const red = suitKey === 'H' || suitKey === 'D';
  return { rank, suit: SUIT_SYMBOL[suitKey] || suitKey, suitKey, red, valid: true };
}
